import React from 'react';
import { Alert, Button } from 'reactstrap';
import { TimesheetStatus } from '../timesheet/Timesheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExclamationTriangle,
    faInfoCircle,
    faUndo,
} from '@fortawesome/free-solid-svg-icons';

export default class CrewTimesheetStatusRow extends React.Component {
    render() {
        const { loading, timesheet, isExported, isAdmin, onRecallRequested } =
            this.props;

        if (
            loading ||
            !timesheet ||
            (timesheet.timesheetStatusId < TimesheetStatus.Submitted &&
                !isAdmin)
        ) {
            return null;
        }

        if (
            isAdmin &&
            timesheet.timesheetStatusId < TimesheetStatus.Submitted
        ) {
            const timesheetStatusNames = Object.keys(TimesheetStatus);
            const timesheetStatusValues = Object.values(TimesheetStatus);

            const timesheetStatusIndex = timesheetStatusValues.indexOf(
                timesheet.timesheetStatusId
            );

            if (timesheetStatusIndex < 0) {
                return null;
            }

            const timesheetStatus = timesheetStatusNames[timesheetStatusIndex];

            return (
                <Alert fade={false} color="warning">
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="mr-2"
                    />
                    This timesheet currently has a status of {timesheetStatus}.
                </Alert>
            );
        }

        if (isExported) {
            return (
                <Alert color="info" fade={false}>
                    <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                    This timesheet has been exported. No further changes may be
                    made.
                </Alert>
            );
        }

        if (timesheet.timesheetStatusId == TimesheetStatus.Submitted) {
            return (
                <Alert color="info" fade={false}>
                    <div className="d-flex w-100">
                        <div className="my-auto">
                            <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-2"
                            />
                            This timesheet has been submitted.
                        </div>
                        {!isAdmin && (
                            <div className="ml-auto">
                                <Button
                                    color="warning"
                                    outline
                                    onClick={onRecallRequested}
                                >
                                    <FontAwesomeIcon
                                        icon={faUndo}
                                        className="mr-2"
                                    />
                                    Recall for edit
                                </Button>
                            </div>
                        )}
                    </div>
                </Alert>
            );
        }

        if (timesheet.timesheetStatusId == TimesheetStatus.Rejected) {
            return (
                <Alert color="warning" fade={false}>
                    <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                    This timesheet has been rejected with the following notes.
                    <hr />
                    {timesheet.rejectionNotes}
                </Alert>
            );
        }

        if (timesheet.timesheetStatusId >= TimesheetStatus.Approved) {
            return (
                <Alert color="success" fade={false}>
                    This timesheet has been approved.
                </Alert>
            );
        }

        return null;
    }
}
